export function getLocale(): string {
    const match = location.pathname.match(/^\/(?<locale>[a-z]{2})\//);
    if (match) {
        // @ts-ignore
        return match.groups.locale;
    }

    return document.documentElement.lang;
}
